/**
 * Enable POS multi-location support
 */
export const ENABLE_MULTI_LOCATION_240724 = 'ENABLE_MULTI_LOCATION_240724';
